import { CompanyListView, CompanyEdit, CompanyCreateView } from './views';
import BusinessIcon from '@material-ui/icons/Business';

export default {
  list: CompanyListView,
  edit: CompanyEdit,
  create: CompanyCreateView,
  icon: BusinessIcon,
};
